import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import wellnessBg from "../../assets/wellness-bg.gif";
import { ArrowRight } from "lucide-react";

const WellnessLanding = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  return (
    <div>
      {/* Hero Section */}
      <section
        data-aos="fade-up"
        className="relative w-full h-[80vh] sm:h-[90vh] flex items-center bg-cover bg-center"
        style={{ backgroundImage: `url(${wellnessBg})` }}
      >
        {/* Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-30"></div>

        {/* Text Content */}
        <div className="relative z-10 text-left text-white px-4 sm:px-8 md:px-12 py-8 sm:py-12 max-w-3xl">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-extrabold leading-snug">
            WELCOME TO <br /> BUTTERFLY WELLNESS
          </h1>
          <p className="mt-3 sm:mt-4 text-base sm:text-lg md:text-xl">
            Healing Minds, Empowering Lives
          </p>
        </div>
      </section>

      {/* Services Section */}
      <section  data-aos="fade-up" className="px-4 sm:px-8 md:px-12 py-8 sm:py-12 bg-white text-center">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4 sm:mb-6">
          HEAL. TRANSFORM. THRIVE
        </h2>
        <p className="max-w-xl sm:max-w-2xl mx-auto text-black mb-8 sm:mb-12 text-sm sm:text-base md:text-base">
          At Butterfly Wellness, we believe true well-being begins with a healthy mind, a nurtured 
          heart, and an empowered spirit. As the wellness division of Butterfly Groups, we provide 
          a trusted sanctuary for holistic growth — supporting your mental, emotional, and spiritual well-being.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 md:gap-6 max-w-4xl mx-auto">
          {[
            "Confidential and compassionate care",
            "Personalized therapy plans",
            "A unique blend of science and soulful healing",
            "Flexible sessions: in-person or online",
          ].map((text, index) => (
            <div
              key={index}
              className="flex items-center justify-start bg-gradient-to-r from-[#00ADA3] to-[#5CCEC4] text-white px-4 sm:px-6 py-3 sm:py-4 rounded-full shadow-lg hover:scale-105 transition-transform"
            >
              <ArrowRight className="mr-2 sm:mr-3 w-4 sm:w-5 h-4 sm:h-5" />
              <span className="text-left text-sm sm:text-base">{text}</span>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default WellnessLanding;
